exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PatientConsentForMedicalRecordsExchange--eFbM-o-KMZlfeOYbkbMR8 {\n  background: linear-gradient(90deg, #d28d00, #f9a100);\n  border-radius: 4px;\n  text-transform: uppercase;\n  color: #fff;\n  text-shadow: 0 -1px 0 #b37700;\n  cursor: pointer;\n  font-weight: bold;\n  margin-left: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"saveButton": "PatientConsentForMedicalRecordsExchange--eFbM-o-KMZlfeOYbkbMR8",
	"saveButton": "PatientConsentForMedicalRecordsExchange--eFbM-o-KMZlfeOYbkbMR8"
};